import React, {
  useRef,
  useState,
} from 'react'
import { connect } from 'react-redux'
import {
  Route,
  useHistory,
} from 'react-router-dom'
import './index.css'
import { useReactToPrint } from 'react-to-print'
import {
  showAccepted,
  isModalOpen,
} from '../../store/actions'
import ModalFilter from '../ModalFilter'
import BaseCheckbox from '../BaseCheckbox'
import BaseRadioButton from '../BaseRadioButon'
import ComponentToPrint from '../PrintVarianceComponent/ComponentToPrint'
import ButtonSecondary from '../ui/ButtonSecondary'
import BaseSearchBar from '../BaseSearchBar'
import DashedLink from '../DashedLink/'
import HOC from '../PrintVarianceComponent/HOC'
import FilterSection from "../ModalFilter/filterSection";


const OrderInfoHeader = ({
  data,
  order,
  onAddPart,
  onSearch,
  onClear,
  onCompleteRun, // <-- ADD
  countingModeInfo: { countingMode, setCountingMode },
  showAccepted,
  show,
  open,
  isModalOpen,
}) => {


  const [searchBarInput, setSearchBarInput] = useState('')

  const onClearLocal = () => {
    setSearchBarInput('');
    onClear();
  }

  const onSearchLocal = async () => {
    onSearch(searchBarInput)
  }

  const onSearchInputChange = (e) => {
    setSearchBarInput(e.target.value)
  }

  const isAddButtonDisabled = () => {
    const status = order.status
    return (
      status === 'canceled' || status === 'aborted' || status === 'completed'
    )
  }
  const onAcceptHandler = () => {
    showAccepted(!show)
  }

  const handleCompleteClick = () => {
    if (typeof onCompleteRun === 'function') {
      onCompleteRun();
    }
  };

  const componentRef = React.useRef()

  let handlePrint = useReactToPrint({
    content: () => componentRef.current,

  })

  return (
    <div className="order-info-header">
      <div className="order-info-header__name">
        <h3 className="order-info-header__title">
          Order Run #{order.runOrder}
        </h3>
        <div>
          <div className='order-info-header__print'>
            <DashedLink name={'Print Variance Report'} onClick={handlePrint} />
            <div style={{ display: 'none' }}><HOC ref={componentRef} data={data} /></div>
          </div>
        </div>
      </div>

      <div className='order-info-bottom'>
        <div className="main">
          <div className='order-info-base-radio-button'>
            <span className="header__action-descriptor">Show First</span>
            <BaseRadioButton key="Parts" labelName="Parts" onClick={setCountingMode} countingMode={countingMode} />
            <BaseRadioButton key="Bin" labelName="Bin" onClick={setCountingMode} countingMode={countingMode} />
          </div>
        </div>
        <FilterSection onAcceptHandler={onAcceptHandler} />

        <div className="order-info-header__actions">
          <span className="header__action-descriptor order-info-header__descr">Search</span>
          <BaseSearchBar
            placeholder="Search Part Number"
            className="order-info-header__search"
            value={searchBarInput}
            onChange={onSearchInputChange}
            onClear={onClearLocal}
            onSearch={onSearchLocal}
          />
          <ButtonSecondary
            name="Search"
            onClick={onSearchLocal}
            className="order-info-header__button"
          />

          <ButtonSecondary
            name="Add Part"
            onClick={onAddPart}
            className="order-info-header__button"
            disabled={isAddButtonDisabled()}
          />

          <ButtonSecondary
            name="Complete"
            onClick={handleCompleteClick}
            className="order-info-header__button"
            disabled={order?.status === 'completed' || order?.status === 'aborted' || order?.status === 'canceled'}
          />
        </div>
      </div>

    </div>
  )
}


const mapStateToProps = ({ data: { show, open } }) => ({ show, open })
const mapDispatchToProps = ({ showAccepted, isModalOpen })

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrderInfoHeader)


